const en = {
  localUsers: {
    title: 'Users',
    desc: 'Password accounts for people outside Entra. Anyone in the directory already signs in with Microsoft; this is only for people who are not in it.',
    name: 'Full name',
    role: 'Role',
    roleLegalAnalyst: 'Legal Analyst',
    roleReviewer: 'Reviewer',
    roleFirmAdmin: 'Firm Admin',
    roleStatsAdmin: 'Stats Admin',
    roleAdmin: 'Admin',
    roleChanged: '{email} is now {role}.',
    firmAdminNeedsFirm: '{email} is now Firm Admin, but with an empty firm id that role can see nobody. Set the firm id.',
    firmAdminNeedsFirmShort: 'Firm id empty: this role can see nobody.',
    firmPrompt: 'Firm id for {email}:',
    firmChanged: 'Firm id updated for {email}.',
    firmId: 'Firm id',
    firmHint: 'The firm id decides which users a "Firm Admin" can see. Left empty, that role sees nobody.',
    create: 'Create',
    existing: 'Existing accounts',
    none: 'No password accounts yet.',
    status: 'Status',
    active: 'Active',
    disabled: 'Disabled',
    pendingChange: 'must change password at first sign-in',
    reset: 'Reset password',
    disable: 'Disable',
    enable: 'Enable',
    remove: 'Delete',
    confirmRemove: 'Permanently delete {email}? This cannot be undone. If the person has not left, "Disable" is safer - the account can be switched back on.',
    removed: 'Account deleted.',
    copyPassword: 'Copy password',
    sendLink: 'Email a sign-in link',
    sendLinkAll: 'Email a sign-in link to every active user',
    confirmSendAll: 'This will email a sign-in link to every active user. Are you sure?',
    linkSentTo: 'Sign-in link sent to {email}',
    bulkResult: 'Sent to {sent}, {failed} failed. From: {from}',
    onceOnly: 'This password is shown once. Share it over a channel you trust; the user must change it at first sign-in.',
    hide: 'Hide',
  },
  budget: {
    tokenUnit: 'tokens',
    tooltip: '{used} / {limit} USD used this month · {tokens} tokens spent. The header figure is in units of 100 tokens.',
    title: 'Usage and Budget',
    perUser: 'Estimated usage per user',
    eachUser: 'user',
    azureSpend: 'Actual Azure spend (month to date)',
    estimateNote: 'The left figure is an ESTIMATE from token counts; the right comes from the Azure bill. They will not match exactly.',
    limit: 'Monthly limit',
    used: 'Used',
    tokens: 'Tokens',
    realTokens: 'Actual token count',
    effectiveRate: 'Effective unit cost',
    byModel: 'By model',
    partialNote: 'Part of this row predates per-model token recording, so the token count is incomplete.',
    calls: 'Calls',
    refresh: 'Refresh',
    stale: 'From cache (Azure rate limit)',
    notConfigured: 'Azure subscription id is not set.',
    loading: 'Loading…',
    unknown: 'Unknown',
  },
  effort: {
    label: 'Effort',
    presets: 'Mode',
    models: 'Model',
    modelAuto: 'Automatic',
    quick: 'Quick',
    thinking: 'Thinking',
    quickHint: 'Faster; skips the senior-partner review pass.',
    thinkingHint: 'Slower; runs the senior-partner review too.',
    quickDiffHint: 'Faster; lists the differences without an AI note per clause.',
    thinkingDiffHint: 'Slower; writes an AI impact note for every changed clause.',
    quickChatHint: 'Faster answers.',
    thinkingChatHint: 'Deeper reasoning; answers take longer.',
  },
  sources: {
    pick: 'Add sources',
    localFile: 'Upload a file',
    myFolders: 'My source folders',
    none: 'No source folders yet. Add one under Settings › Source Folders.',
    remove: 'Remove source',
    title: 'Source Folders',
    desc: 'Choose what the AI looks at. A folder holds references, not copies, and access is re-checked on every read.',
    newFolder: 'New folder',
    name: 'Folder name',
    visibility: 'Visibility',
    private: 'Only me',
    firm: 'Whole firm',
    items: 'items',
    empty: 'This folder is empty.',
    save: 'Save',
    delete: 'Delete',
    confirmDelete: 'Delete this folder?',
    localHint: 'Picking a folder from your computer works only in Chrome and Edge, and asks for permission again each session.',
    pickLocal: 'Pick a folder from this computer',
    ownerOnly: 'Only the owner can change this folder.',
  },
  talent: {
    pick: 'Pick a talent',
    clear: 'Clear talent',
    analyze: 'Document Analysis',
    compare: 'Document Comparison',
    draft: 'Draft a document',
    caseDocs: 'Search my case files',
    caselaw: 'Search case law',
    mevzuat: 'Legislation / view a law',
    articles: 'Compare articles',
    calculate: 'Calculation',
    web: 'Search the web',
  },
  appName: 'B-Agent Law',
  nav: {
    dashboard: 'Dashboard',
    contractAnalysis: 'Document Analysis',
    legislationDiff: 'Document Comparison',
    caseLaw: 'Case Law',
    ministry: 'Ministry Decisions',
    generator: 'Doc Generator',
    converter: 'Format Converter',
    hesaplama: 'Calculators',
    caseFiles: 'My Files (UYAP)',
    chat: 'Chat',
    activity: 'Activity',
    admin: 'Admin',
    settings: 'Settings',
    mainNav: 'Main navigation',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
  },
  auth: {
    or: 'or',
    email: 'E-mail',
    password: 'Password',
    currentPassword: 'Current password',
    newPassword: 'New password (at least 12 characters)',
    signingIn: 'Signing in…',
    signInFailed: 'Sign-in failed.',
    setPasswordAndSignIn: 'Set password and sign in',
    mustChangePassword: 'You must change your password on first sign-in.',
    rememberMe: 'Remember me',
    rememberMeHint: 'Your email is remembered on this device and your session lasts longer. For security, your password is still required after 30 minutes of inactivity.',
    emailLinkButton: 'Email me a sign-in link',
    emailLinkHint: 'If you do not know your password, we can email a single-use sign-in link to your address.',
    emailLinkSent: 'If that address has an account, a sign-in link is on its way.',
    emailLinkSigningIn: 'Checking your sign-in link…',
    emailRequired: 'Enter your email address first.',
    forgotPassword: 'I forgot my password',
    forgotPasswordHint: 'We will email a single-use sign-in link to your address; once you are in you can choose a new password.',
    linkSignedInAs: 'Sign-in link verified:',
    setPasswordAndContinue: 'Set password and continue',
    continueWithoutPassword: 'Continue without setting one',
    signIn: 'Sign in',
    logOut: 'Log out',
    loginSubtitle: 'Choose a role to continue',
    role: 'Role',
    bothSubtitle: 'Sign in with your Microsoft account, or with your email and password',
    entraSubtitleMicrosoft: 'Sign in with your Microsoft account',
    signInMicrosoft: 'Sign in with Microsoft',
    sessionExpired: 'Your session expired, so you were signed out. Please sign in again.',
    sessionIdle: 'You were signed out after a period of inactivity. Please sign in again.',
    idleWarning: 'You will be signed out in {seconds} seconds due to inactivity.',
    staySignedIn: 'Stay signed in',
    entraFailed:
      'Microsoft sign-in did not complete. In a normal browser the app uses a full-page redirect (check that the exact site URL is registered in Entra). In Microsoft Teams or an embedded window, allow pop-ups for this site. If it continues, ask an admin to verify the app registration (redirect URI, API permissions, and admin consent).',
  },
  dashboard: {
    title: 'Dashboard',
    desc: 'Choose a flow to start.',
    contractCardTitle: 'Document Analysis',
    contractCardDesc: 'Upload a contract (PDF/DOCX), get a Risk Haritası table with risk level, explanation, recommendation, and suggested rewrite. Export to Word or PDF.',
    diffCardTitle: 'Document Comparison',
    diffCardDesc: 'Select two versions of a law from the curated dataset. View article-based diff with sources. Citations required – missing sources trigger refusal.',
    caseLawCardTitle: 'Case Law (Emsal)',
    caseLawCardDesc: 'Search court decisions from the UYAP emsal index. Filter by chamber, case number, decision number, and date range.',
    generatorCardTitle: 'Document Generator',
    generatorCardDesc: 'Generate contracts, petitions, policies, guides, and briefings with AI, or create contracts, petitions, agreements, notices and more from ready-made legal templates. Download as DOCX + PDF.',
    recentActivity: 'Recent Activity',
    noRecentActivity: 'No activity yet.',
    taskTypes: {
      contract_analysis: 'Document Analysis',
      legislation_diff: 'Legislation Diff',
      custom_document_diff: 'Custom Document Diff',
      document_generation: 'Document Generation',
      upload: 'File Upload',
      export: 'Export',
      format_convert: 'Format Conversion',
    },
  },
  contract: {
    title: 'Document Analysis',
    desc: 'Upload a contract (PDF or DOCX) to get a Risk Map and optional suggested wording.',
    selectFile: 'File (PDF/DOCX)',
    docNameOptional: 'Document name (optional)',
    upload: 'Upload',
    uploading: 'Uploading…',
    runAnalysis: 'Run analysis',
    analyzing: 'Analyzing…',
    uploaded: 'Uploaded',
    exportWord: 'Export to Word',
    assistantTitle: 'Ask about this analysis',
    assistantHint: 'Ask questions about the document analysis on screen.',
    exportPdf: 'Export to PDF',
    exporting: 'Exporting…',
    showSuggestedWording: 'Show suggested wording',
    suggestedWordingFull: 'Suggested wording (full)',
    sectionClause: 'Section/Clause',
    riskLevel: 'Risk Level',
    riskExplanation: 'Risk Explanation',
    recommendation: 'Recommendation',
    suggestedRewrite: 'Suggested Rewrite',
    contractType: 'Contract Type',
    overallRisk: 'Overall Risk Score',
    riskSummary: 'Overall Assessment',
    clauseType: 'Clause Type',
    keyTerms: 'Key Terms',
    findings: 'Findings',
    issue: 'Issue',
    legalBasis: 'Legal Basis',
    missingClauses: 'Missing / Recommended Clauses',
    missingClausesDesc: 'Standard protections expected for this contract type but not found in the text:',
    noMissingClauses: 'All expected standard clauses appear to be present.',
    filterSeverity: 'Filter by risk level',
    all: 'All',
    showRewrite: 'Show suggested wording',
    detectedType: 'Detected type',
    findingsCount: 'findings',
    viewSource: 'View source',
    execSummary: 'Executive assessment',
    favours: 'Balance of the contract',
    dealBreakers: 'Must change before signing',
    topRisks: 'Top risks',
    compliance: 'Compliance flags',
    negotiationPlan: 'Negotiation plan',
    keyTermsDoc: 'Key contract terms',
    marketStandard: 'Market standard',
    negotiationPosition: 'Negotiation position',
    exposure: 'Exposure',
    invalidityRisk: 'Invalidity risk',
    analyzingDeep: 'Running deep analysis',
  },
  caselaw: {
    title: 'Case Law (Emsal / İçtihat)',
    desc: 'Search court decisions from the UYAP emsal index. Enter keywords or leave empty for recent decisions; optionally filter by decision date.',
    query: 'Search',
    queryPlaceholder: 'Keywords (or leave empty for recent)',
    fromDate: 'From date',
    toDate: 'To date',
    sortOrder: 'Sort order',
    sortNewest: 'Newest first (by decision date)',
    sortOldest: 'Oldest first (by decision date)',
    chamber: 'Chamber (Daire)',
    chamberPlaceholder: 'e.g. 11. HD',
    esasNo: 'Esas No',
    kararNo: 'Karar No',
    sourceType: 'Source Type',
    courtType: 'Court Type',
    courtTypeAll: 'All courts',
    chamberAll: 'All chambers',
    sourceAll: 'All',
    sourceYargitay: 'Yargıtay',
    sourceDanistay: 'Danıştay',
    sourceBolgeAdliye: 'Regional Court',
    tabDecisions: 'Court Decisions',
    tabMinistry: 'Ministry Decisions',
    relatedDocs: 'Related Legislation & Ministry Documents',
    docsLegislation: 'Legislation',
    docsMinistry: 'Ministry Decisions',
    showMore: 'Show more',
    showLess: 'Show less',
    sourceMevzuat: 'Legislation',
    sourceBakanlik: 'Ministry',
    filters: 'Filters',
    advancedFilters: 'Advanced Filters',
    clearFilters: 'Clear all',
    search: 'Search',
    searching: 'Searching…',
    searchFailed: 'Search failed',
    apiUnreachable: 'Cannot reach the API. Please try again later or contact your administrator.',
    notConfigured: 'Case law search is not currently available. Please try again later.',
    resultsCount: 'Showing {count} of {total} results',
    resultsRange: 'Showing {from}–{to} of {total} results (page {page} of {totalPages})',
    pageOf: 'Page {page} of {totalPages}',
    prevPage: 'Previous',
    nextPage: 'Next',
    noBodyText: 'Decision body text is missing in this record or stored under another field. Try opening the full text via UYAP.',
    compareFailed: 'Comparison failed.',
    noTextForCompare: 'One or both selected decisions have no full text; indexed text is required to compare.',
    noResults: 'No decisions found.',
    viewOnUyap: 'View on UYAP',
    showFull: 'Show full decision',
    downloadPdf: 'Download PDF',
    downloadText: 'Download Text',
    summarize: 'Summarize',
    summarizing: 'Summarizing…',
    summaryTitle: 'AI Summary',
    keyPrinciples: 'Key Principles',
    relevance: 'Relevance',
    compare: 'Compare',
    comparing: 'Comparing…',
    selectToCompare: 'Select 2 decisions to compare',
    compareSelected: 'Compare Selected',
    commonPrinciples: 'Common Principles',
    differences: 'Differences',
    analysis: 'Analysis',
    relatedLegislation: 'Related Legislation',
    loadingRefs: 'Loading legislation references…',
    noRefsFound: 'No legislation references found.',
    semanticSearch: 'Semantic ranking (conceptual search)',
    semanticSearchHint:
      'Helps with full phrases and concepts (e.g. workplace accident compensation) without exact keywords. Requires a semantic configuration on the index; returns at most 50 results.',
    semanticActive: 'Semantic ranking applied',
    semanticFallback: 'Semantic ranking was unavailable; using keyword search instead.',
  },
  ministry: {
    title: 'Ministry Decisions',
    desc: 'Search regulations, communiqués, circulars and decisions from all ministries.',
    query: 'Search',
    queryPlaceholder: 'Keywords (or leave blank)',
    bakanlik: 'Ministry',
    allMinistries: 'All Ministries',
    type: 'Type',
    allTypes: 'All Types',
    kararNo: 'Decision No',
    kararNoPlaceholder: 'e.g. 2024/15',
    fromDate: 'From date',
    toDate: 'To date',
    clearFilters: 'Clear filters',
    search: 'Search',
    searching: 'Searching…',
    resultCount: '{n} results',
    noResults: 'No results found.',
    viewSource: 'View source',
    notConfigured: 'The ministry decisions index is not configured yet. Run scripts/sync_bakanlik_decisions.py and set SEARCH_BAKANLIK_INDEX to enable it.',
  },
  chat: {
    placeholder: 'Ask a question…',
    // See the note in tr.js: label + hint are what the card shows, the long string is what
    // clicking puts in the composer.
    example1Label: 'Wage base',
    example1Hint: 'How severance and notice pay are calculated',
    example1: 'How is the wage base for severance and notice pay calculated? Explain with Court of Cassation rulings.',
    example2Label: 'Non-compete',
    example2Hint: 'Duration and territorial limits that apply',
    example2: 'What duration and territorial limits does Turkish law place on a non-compete clause?',
    example3Label: 'Personnel files',
    example3Hint: 'Retention and disposal under KVKK',
    example3: 'Under KVKK, how long should employee personnel files be retained?',
    example4Label: 'Notice letter',
    example4Hint: 'Draft for termination with just cause',
    example4: 'Draft a notice letter for termination with just cause.',
    inputPlaceholder: 'Type your question…',
    send: 'Send',
    sending: 'Sending…',
    you: 'You',
    assistantName: 'B-Agent Law Assistant',
    statusThinking: 'Thinking…',
    statusTool: 'Checking sources…',
    statusTool_search_mevzuat: 'Searching legislation…',
    statusTool_search_caselaw: 'Searching case law…',
    statusTool_search_case_docs: 'Searching case documents…',
    statusTool_analyze_contract: 'Analysing the document…',
    statusTool_compare_documents: 'Comparing documents…',
    statusTool_compare_articles: 'Comparing articles…',
    statusTool_draft_document: 'Drafting…',
    statusTool_calculate: 'Calculating…',
    statusTool_search_web: 'Searching the web…',
    error: 'Failed to get a reply.',
    expand: 'Open in full screen',
    newChat: 'New chat',
    edit: 'Edit',
    previousVersions: '{n} earlier response(s)',
    previousNoReply: '(no reply was received)',
    resend: 'Resend',
    history: 'Chat history',
    noHistory: 'No conversations yet.',
    messagesCount: 'messages',
    deleteConvo: 'Delete conversation',
    hideSidebar: 'Hide history',
    showSidebar: 'Show history',
    attachFile: 'Attach file (PDF/DOCX/TXT)',
    removeFile: 'Remove attachment',
    fileAttached: 'Attached',
    speakMessage: 'Read aloud',
    stopSpeaking: 'Stop reading',
    startListening: 'Speak (voice input)',
    stopListening: 'Stop listening',
    sttNotSupported: 'Voice input not supported in this browser',
    exportWord: 'Download Word',
    exportPdf: 'Download PDF',
    exporting: 'Downloading…',
  },
  chatCard: {
    articleCompare: 'Article comparison',
    openFullAnalysis: 'Open full analysis',
    openFullComparison: 'Open full comparison',
    moreFindings: '+{n} more findings',
    caseDocs: 'From your case files',
    fromCases: '{n} case(s) searched',
    readSource: 'Read the full decision here',
    loadingSource: 'Fetching the decision…',
    openSource: 'Open the source in a new tab',
    sources: 'Sources',
    myDocuments: 'Your documents',
    analyzing: 'Analyzing contract…',
    riskMap: 'Risk Map',
    riskScore: 'Risk score: {n}',
    comparing: 'Comparing documents…',
    comparison: 'Comparison',
    drafting: 'Drafting document…',
    document: 'Draft document',
    blockCount: '{n} sections',
    showFull: 'Show full text',
    showLess: 'Show less',
    openInStudio: 'Open in Doc Generator',
    caselaw: 'Decisions found',
    web: 'Web results',
    webNote: 'Not an official source; verify at the source before relying on it.',
    mevzuat: 'Relevant legislation',
    calculation: 'Calculation',
    showingOf: '{count} of {total} results',
  },
  sidebar: {
    talents: 'Talents',
    chats: 'Chats',
    showSection: 'Expand section',
    hideSection: 'Collapse section',
    searchChats: 'Search chats…',
    noChatMatch: 'No matching chats.',
  },
  copilot: {
    title: 'B-Agent Assistant',
    collapsePanel: 'Collapse panel',
    expandPanel: 'Open assistant',
    contextChipTitle: 'The assistant knows which page is open.',
    contextHint: 'The user is currently on the "{page}" page. Answer in the context of that page.',
    emptyTitle: 'What would you like to do?',
    emptyDesc: 'Type a question, or pick one of the suggestions below.',
    prompts: {
      whatCanIDo: 'What can I do on this page?',
      summarizeDay: 'Summarise my outstanding work',
      riskyClauses: 'Which clauses in the contract are risky?',
      explainAnalysis: 'Explain the analysis result in plain language',
      findPrecedent: 'Find a precedent on this subject',
      summarizeDecision: 'Summarise this decision',
      recentDecisions: 'Show recent ministry decisions',
      whichCalculation: 'Which calculation should I use?',
      caseStatus: 'What is the status of my case files?',
      whichFormat: 'Which format should I convert to?',
    },
  },
  hesaplama: {
    selectCalculator: 'Calculator',
    title: 'Calculators',
    desc: 'Legal calculators – results are produced by deterministic, law-based formulas.',
    soon: 'Soon',
    hesapla: 'Calculate',
    faiz: 'Interest Calculation',
    anapara: 'Principal',
    faizOrani: 'Interest Rate',
    baslangic: 'Start Date',
    bitis: 'End Date',
    yontem: 'Method',
    basit: 'Simple Interest',
    bilesik: 'Compound Interest',
    gun: 'Days',
    faizTutari: 'Interest Amount',
    toplam: 'Total (Principal + Interest)',
    vekalet: 'Attorney Fee (AAÜT)',
    harc: 'Court Fee',
    infaz: 'Sentence Execution',
    davaDegeri: 'Case Value',
    vekaletUcreti: 'Attorney Fee',
    tarife: 'Tariff',
    nispiHarc: 'Proportional Judgment Fee',
    pesinHarc: 'Advance Fee (1/4)',
    cezaYil: 'Sentence (Years)',
    cezaAy: 'Sentence (Months)',
    cezaGun: 'Sentence (Days)',
    mahsup: 'Time Served (days)',
    sucTipi: 'Offence Type',
    infazSuresi: 'Execution Period (in prison)',
    ksKalan: 'Until Conditional Release',
    denetimli: 'Probation',
    fiilenKurum: 'Actual Time in Prison',
    // Severance / Notice / Leave
    tazminat: 'Severance / Notice / Leave',
    iseBaslama: 'Start of Employment',
    isAyrilma: 'End of Employment',
    brutUcret: 'Monthly Gross Wage (all-in)',
    kidemTavani: 'Severance Ceiling (blank = current)',
    kullanilmayanIzin: 'Unused Leave (days)',
    hizmetSuresiLbl: 'Length of Service',
    kidemTazminati: 'Severance Pay (net)',
    ihbarTazminati: 'Notice Pay (net)',
    izinUcreti: 'Annual Leave Pay (gross)',
    brutLbl: 'Gross',
    netLbl: 'Net',
    // Stamp tax
    damga: 'Stamp Tax',
    tutar: 'Amount',
    damgaTuru: 'Document Type',
    damgaSozlesme: 'Contract (0.948%)',
    damgaUcret: 'Wage / Compensation (0.759%)',
    damgaKira: 'Lease (0.189%)',
    oranBinde: 'Rate (per mille)',
    damgaVergisi: 'Stamp Tax',
    // VAT
    kdv: 'VAT',
    kdvOran: 'VAT Rate (%)',
    kdvMod: 'Calculation',
    kdvHaric: 'VAT Excluded (add on top)',
    kdvDahil: 'VAT Included (extract)',
    matrah: 'Base',
    kdvTutari: 'VAT Amount',
    // Rent increase
    kira: 'Rent Increase',
    mevcutKira: 'Current Rent (TL)',
    tufeOrani: 'CPI Rate (%)',
    kiraTuru: 'Lease Type',
    kiraKonut: 'Residential (25% cap)',
    kiraIsyeri: 'Commercial (no cap)',
    uygulananOran: 'Applied Rate',
    artisTutari: 'Increase Amount',
    yeniKira: 'New Rent',
    // Alimony increase
    nafaka: 'Alimony Increase',
    mevcutNafaka: 'Current Alimony (TL)',
    artisOrani: 'Increase Rate (%)',
    yeniNafaka: 'New Alimony',
    // Late-payment surcharge
    gecikme: 'Late-Payment Surcharge',
    borc: 'Debt (TL)',
    vade: 'Due Date',
    odeme: 'Payment Date',
    aylikOran: 'Monthly Rate (%)',
    gecikmeZammi: 'Late Surcharge',
  },
  uyap: {
    title: 'My Files (UYAP)',
    desc: 'Keep your UYAP lawyer and corporate documents in per-case folders, stay notified of progress, and ask AI directly about your files.',
    eimzaTitle: 'E-signature / Mobile signature verification',
    eimzaDesc: 'This section holds your UYAP documents. Verify your identity with e-imza or mobile signature to access it.',
    eImzaCard: 'E-imza (card)',
    eImzaCardVerify: 'Verify with my card',
    eImzaCardHint: 'Leave your card in the reader. When you press verify, the browser asks you to choose a certificate and the card software asks for your PIN. The signature is made inside the card - neither the PIN nor the private key ever reaches the server.',
    eimzaNoCert: 'The browser sent no card certificate. If no certificate picker appeared, client certificates are not enabled on the server.',
    eimzaTicketStale: 'The verification request timed out. Please try again.',
    eimzaCardRefused: 'The card certificate was not accepted ({reason}).',
    eimzaNoProvider: 'E-imza cannot be verified on this deployment. Even with your card in the reader, the signature is produced in the browser and the server needs a licensed validation provider (Kamu SM, or a GSM operator for mobile signature) to check it. None is configured and strict mode is on, so every attempt fails. This is a configuration and contracting step, not something the app can work around.',
    eimzaDemoNote: 'No real signature provider is configured; verification here is a demo flow in this environment. Connect Kamu SM / a GSM mobile-signature provider for production.',
    mobilImza: 'Mobile Signature',
    eImza: 'E-signature (smart card)',
    tckn: 'National ID (TCKN)',
    phone: 'Mobile Phone',
    eImzaHint: 'Insert your smart card and ensure the middleware is running, then verify.',
    verify: 'Verify',
    verifying: 'Verifying…',
    eimzaFailed: 'Signature could not be verified.',
    casesTitle: 'Cases',
    newCase: 'New Case',
    caseNo: 'Case No (e.g. 2024/123)',
    caseTitle: 'Case Title',
    court: 'Court / Unit',
    client: 'Client',
    create: 'Create',
    noCases: 'No cases yet. Create a new case.',
    selectCase: 'Select a case to see its details.',
    notFound: 'Case not found.',
    docs: 'docs',
    documents: 'Documents',
    uploadDoc: 'Upload Document',
    uploading: 'Uploading…',
    noDocs: 'No documents in this case.',
    uploaded: 'Uploaded',
    sync: 'Sync from UYAP',
    progress: 'Case Progress',
    progressTitle: 'Progress title (e.g. Hearing postponed)',
    progressDetail: 'Detail (optional)',
    notifyEmail: 'Notification email (optional)',
    notifyEmailDisabled: 'Email notifications not configured',
    addProgress: 'Add Progress',
    noProgress: 'No progress recorded yet.',
    askTitle: 'AI Assistant – about this case',
    askPlaceholder: 'Ask about the documents in this case; answers are grounded in your files and the law.',
    askInput: 'Ask about this case…',
    askFailed: 'Could not answer the question.',
    notifications: 'Notifications',
    markAllRead: 'Mark all read',
    noNotifications: 'No notifications.',
    // Client TCKN + Citizen portal
    clientTckn: 'Client National ID (optional)',
    clientTcknHint: 'If a TCKN is entered, the client can see this case from the Citizen portal.',
    portalLawyer: 'Lawyer',
    portalCitizen: 'Citizen',
    portalKurum: 'Institution',
    myCasesTitle: 'My Cases',
    citizenNoCases: 'No cases found under your name. They appear here once your lawyer links the case to your National ID.',
    // UYAP portal connection
    connectTitle: 'UYAP Connection',
    connectDesc: 'Connect to the UYAP Lawyer, Institution or Citizen portal; your cases are imported automatically, folder by folder.',
    connect: 'Connect to UYAP',
    connecting: 'Connecting…',
    connectFailed: 'Could not connect to UYAP.',
    connected: 'Connected',
    connectedAs: 'Connected: {portal}',
    disconnect: 'Disconnect',
    portalAvukat: 'Lawyer Portal',
    portalKurumFull: 'Institution Portal',
    portalVatandasFull: 'Citizen Portal',
    certPassword: 'E-signature PIN / certificate password',
    certHint: 'Your e-signature certificate is verified via smart card/middleware or a licensed gateway.',
    tcknFromEimza: 'Left blank, taken from your e-signature identity',
    lastSync: 'Last sync',
    casesWord: 'cases',
    syncedSummary: '{cases} cases found, {docs} new documents imported.',
    mode_external: 'Live UYAP gateway',
    mode_puppeteer: 'Portal automation',
    mode_demo: 'Demo connector',
    mode_none: 'Not configured',
    notConfiguredTitle: 'Live UYAP access is not set up yet',
    notConfiguredDesc: 'Two routes enable this. 1) A licensed UYAP gateway operated by the firm (Adalet Bakanlığı agreement). 2) The lawyer’s own e-imza: the certificate is a smart card physically in their machine, so the server cannot sign in on their behalf — that route needs a small bridge running on the lawyer’s own computer. Either way this section activates with a single setting (UYAP_SYNC_URL).',
    notConfiguredLawyerNote: 'With mobile signature the signing happens on the phone, so a local bridge may not be needed; that route should be checked separately against UYAP terms of use.',
    demoWarning: 'Demo connector active: the cases shown are samples, not real UYAP data.',
    // Document AI summary
    aiSummary: 'AI Summary',
    aiSummaryLoading: 'Preparing summary…',
    aiSummaryNone: 'No summary yet for this document.',
    aiSummaryFailed: 'Could not generate summary.',
    showSummary: 'Show AI Summary',
    hideSummary: 'Hide Summary',
    useInDraft: 'Use in Draft',
    useInDraftHint: 'Use this document as a source in the Document Generator',
    // Hearing calendar
    hearings: 'Hearings',
    noHearings: 'No scheduled hearings.',
    nextHearing: 'Next hearing',
    syncNow: 'Sync Now',
    syncing: 'Syncing…',
    needsConnection: 'Connect to UYAP first to sync.',
  },
  convert: {
    title: 'Format Converter',
    desc: 'Convert between Word, PDF, UYAP (.udf) and plain text. Files are held in memory for the conversion only and are never stored on the server.',
    dropTitle: 'Drag a file here, or click to choose one',
    dropHint: 'Word (.docx, .doc), PDF, UYAP (.udf) or text (.txt) — max 15 MB',
    badType: 'Unsupported file type. Upload a Word, PDF, UDF or TXT file.',
    targetLabel: 'Target format',
    convert: 'Convert',
    converting: 'Converting…',
    reset: 'Clear',
    done: 'Conversion complete',
    download: 'Download',
    diMissing: 'Azure Document Intelligence is not configured: DOCX, PDF, UDF and TXT conversions work, but legacy .doc files and scanned (image) PDF pages cannot be read.',
    sourceUnavailable: 'Reading legacy .doc files requires Azure Document Intelligence, which is not currently configured. Save the file as .docx in Word and try again.',
  },
  docActions: {
    print: 'Print',
    fillStyle: 'Fill-in fields',
    fillMarker: 'Show as markers (⟪…⟫)',
    fillDots: 'Blank line (…………)',
    fillUnderscore: 'Blank line (_____)',
    fillPlain: 'Label only',
    fillCount: '{count} fields to fill in',
    fillHint: 'This document has fields meant to be completed by hand. Pick a style to turn them into blank lines when printing or exporting.',
  },
  drafting: {
    save: 'Save',
    saving: 'Saving…',
    saved: 'Saved',
    unsavedWarning: 'This document is not saved yet. Refreshing or switching device will lose it — press Save to keep it.',
    savedDocs: 'My saved documents',
    uploadSources: 'Upload files (use as sources)',
    uploadSourcesHint: 'The AI follows the wording, party names and defined terms in these files. Up to 5 files.',
    uploadingSources: 'Uploading source files…',
    effort: 'Effort',
    effortLow: 'Low',
    effortMedium: 'Medium',
    effortHigh: 'High',
    composerGreeting: 'What should I draft for you?',
    dictate: 'Dictate',
    dictateStop: 'Stop',
    dictateUnsupported: 'Dictation is not supported in this browser (use Chrome or Edge).',
    title: 'Document Generator',
    desc: 'Create source-grounded contracts and petitions with AI; see the legislation and case law behind each sentence, edit it, and export.',
    tabAi: 'Create with AI',
    tabTemplates: 'Templates',
    belgeTuru: 'Document Type',
    belgeTuruPlaceholder: 'Choose a document type (optional)',
    docTitle: 'Title',
    docTitlePlaceholder: 'e.g. Non-Disclosure Agreement',
    parties: 'Parties',
    partiesPlaceholder: 'e.g. ABC Inc. – XYZ Ltd.',
    matter: 'Matter / Facts',
    matterPlaceholder: 'Describe the subject and key facts…',
    instructions: 'Instructions',
    instructionsPlaceholder: 'Special requests (e.g. add penalty clause, venue Istanbul)…',
    talimatlarPlaceholder: 'Describe what you want. e.g. "Draft a service agreement between X Inc. and Y Ltd. for software development; fee 150,000 TL/month, include confidentiality and penalty clauses, venue Istanbul."',
    talimatlarHint: 'It infers the document type, parties and subject automatically and grounds the draft in relevant legislation and case law.',
    advanced: 'Advanced (sources)',
    sourcesLabel: 'Research Sources',
    addSource: 'Add Source (UYAP doc / note)',
    addSourcePlaceholder: 'Source title or case document name…',
    add: 'Add',
    ownDocs: 'My own documents (UYAP / corporate)',
    ownDocsHint: 'Pick documents from your files; the AI will follow their wording, party names, and defined terms when generating.',
    ownDocsNone: 'No files yet. Add documents from the "My Files (UYAP)" section.',
    generate: 'Generate Document',
    generating: 'Generating…',
    newDoc: 'New Document',
    stubWarning: 'AI not configured – a structural skeleton was generated (no citations).',
    panelChat: 'AI Assistant',
    panelSources: 'Sources',
    panelAssistant: 'AI Assistant',
    modeAsk: 'Ask about the document',
    modeEdit: 'Edit the document',
    askHint: 'Ask about this document; answers are grounded in the document text and sources.',
    editHint: 'Describe the change you want across the whole document; the AI rewrites it and saves a new version.',
    askInput: 'Ask about the document…',
    editInput: 'What should change? (e.g. add a penalty clause, update the parties)…',
    apply: 'Apply',
    docRevised: 'Document updated and saved as a new version.',
    version: 'Version',
    versions: 'Versions',
    noSources: 'No cited sources in this document.',
    selectBlock: 'Select a section of the document to edit.',
    sectionEdit: 'Selected section',
    clearSection: 'Clear selection',
    clickToEdit: 'Click to edit',
    editPlaceholder: 'How should I change this section? (e.g. make stricter, add a clause)',
    applyEdit: 'Apply',
    editing: 'Editing…',
    emailSubject: 'Subject',
    model: 'AI model',
    modelUnavailable: 'not configured on the server',
    modelUnavailableHint: 'The deep model is not configured on the server. It becomes selectable once an admin sets AZURE_AI_SMART_DEPLOYMENT.',
    modelSmart: 'Deep model',
    modelSmartHint: 'Reasoning model: planning, section-by-section drafting, partner-level review. Slower, far deeper.',
    modelFast: 'Fast model',
    modelFastHint: 'Runs the same pipeline faster, with slightly less depth.',
    depth: 'Depth',
    depthFull: 'Full (review + lawyer notes)',
    depthQuick: 'Quick (draft only)',
    pipelinePlan: 'Analysing the instruction',
    pipelineRunning: 'Preparing the document',
    panelNotes: 'Lawyer notes',
    notesSummary: 'Summary',
    notesOpenPoints: 'To confirm with the client',
    notesRisks: 'Residual risks',
    notesNegotiation: 'Negotiation notes',
    notesChecklist: 'Pre-signature checklist',
    notesNextSteps: 'Next steps',
    notesNone: 'No lawyer notes were produced for this document.',
    reviewVerdict: 'Review verdict',
    reviewIssues: 'Fixed in review',
    assumption: 'Assumption used',
    editNote: 'Why this changed',
    modelBadge: 'Model',
  },
  generator: {
    title: 'Document Generator',
    assistantTitle: 'AI Assistant',
    assistantHint: 'Help with document drafting: draft text, suggest clauses, and refine wording. Rely only on actual Turkish legislation and case law; never invent article or decision numbers you are unsure of.',
    history: 'History',
    historyTitle: 'Previous Documents',
    historyClear: 'Clear History',
    desc: 'Generate policies and guides with AI templates, or create contracts and legal documents from ready-made form templates.',
    searchPlaceholder: 'Search templates or document names…',
    noTemplates: 'No matching templates found.',
    loadError: 'Could not load templates. Please refresh the page.',
    aiTemplates: 'AI Templates',
    legalTemplates: 'Legal Document Templates',
    aiPowered: 'AI',
    questions: 'questions',
    backToTemplates: 'Back to templates',
    backToForm: 'Back to form',
    topic: 'Topic',
    topicPlaceholder: 'Main topic of the document',
    scope: 'Scope (optional)',
    scopePlaceholder: 'Which teams/processes does it cover',
    targetAudience: 'Target Audience (optional)',
    targetAudiencePlaceholder: 'e.g. All employees, Legal team',
    keyPoints: 'Key Points (optional)',
    keyPointsPlaceholder: 'One item per line',
    selectOption: '– Select –',
    loadingFields: 'Loading questions…',
    generate: 'Generate',
    generating: 'Generating…',
    result: 'Generated Document',
    disclaimer: '',
    copyToClipboard: 'Copy',
    copied: 'Copied!',
    downloadDocx: 'Download DOCX',
    downloadPdf: 'Download PDF',
  },
  diff: {
    title: 'Legislation Diff',
    assistantTitle: 'AI Assistant',
    assistantHint: 'Help with legislation and document comparison: explain articles and interpret the impact of changes. Rely only on actual Turkish legislation and case law; never invent article or decision numbers you are unsure of.',
    clickRowHint: 'Click a row to discuss that change with the AI assistant.',
    assistantHintCustom: 'The text of the two uploaded documents is included below. Explain the differences based on these documents and actual Turkish legislation/case law; never invent article or decision numbers you are unsure of.',
    history: 'History',
    historyTitle: 'Previous Comparisons',
    historyClear: 'Clear History',
    desc: 'Select a law and two versions from the curated dataset. Diff is citations-first; missing sources will refuse the result.',
    law: 'Law',
    oldVersion: 'Old version',
    newVersion: 'New version',
    runDiff: 'Run diff',
    running: 'Running diff…',
    select: '– Select –',
    refusalTitle: 'Refusal: citations required',
    missingSources: 'Missing sources',
    articleClause: 'Article/Clause',
    oldText: 'Old Text',
    newText: 'New Text',
    changeType: 'Change Type',
    summaryImpact: 'Summary/Impact Note',
    sources: 'Sources',
    export: 'Export',
    exportText: 'Export as Text',
    liveData: 'Live legislation data',
    lawsIndexed: 'laws indexed',
    lawNoShort: 'No.',
    lawNoPrefix: 'No.',
    articleLabel: 'Article',
    typeaheadMore: 'more laws – narrow your search',
    firstLaw: 'First Law',
    secondLaw: 'Second Law',
    searchLaw: 'Type law name or number to search…',
    selectTwoLaws: 'Select two different laws to compare',
    compareLaws: 'Compare Laws',
    browseLaw: 'Browse Law',
    selectLawToBrowse: 'Select a law to view its articles',
    articles: 'articles',
    filterArticles: 'Filter articles by number or keyword…',
    loadingArticles: 'Loading articles…',
    loadingLaws: 'Loading laws…',
    noArticles: 'No articles found.',
    uploadCompare: 'Upload & Compare',
    uploadDocs: 'Add documents (2–5)',
    uploadDocsHint: 'Up to {max} documents. One is the baseline; the others are compared against it.',
    baseline: 'Baseline',
    setBaseline: 'Set as baseline',
    uploadDocA: 'Document A',
    uploadDocB: 'Document B',
    uploadAndCompare: 'Upload & Compare',
    uploading: 'Uploading…',
    mixedCompare: 'Mixed Compare',
    fromIndex: 'From Index',
    fromUpload: 'Upload',
    exportCsv: 'Export as CSV',
  },
  audit: {
    title: 'Activity / Audit',
    desc: 'Administrators see activity from all users. Reviewers see only their own rows. Columns: user, timestamp, task type, tools, sources, output version.',
    time: 'Time',
    user: 'User',
    taskType: 'Task type',
    toolsCalled: 'Tools called',
    sourcesUsed: 'Sources used',
    outputVersion: 'Output version',
    noActivity: 'No activity yet.',
    descAdmin: 'Activity for all users. Filter by user, task type and date range, then export the same selection as CSV/JSON.',
    filterUser: 'User',
    allUsers: 'All users',
    filterTask: 'Task type',
    allTasks: 'All tasks',
    from: 'From',
    to: 'To',
    clearFilters: 'Clear filters',
    exportCsv: 'Download CSV',
    exportJson: 'Download JSON',
    showing: 'Showing {count} events',
    showingOf: 'Showing the {count} most recent of {total} events',
    loading: 'Loading events…',
    noMatch: 'No events match these filters.',
  },
  settings: {
    title: 'Settings',
    desc: 'Appearance and preferences.',
    appearance: 'Appearance',
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',
    about: 'About',
    aboutText: 'B-Agent Law – AI-Powered Legal Assistant. Contract analysis, legislation comparison, case law search, and document generation.',
    retentionTitle: 'Data retention and deletion (KVKK)',
    retentionNote: 'Documents can be deleted from the document list at any time. If a retention policy is configured, documents older than the retention period may be removed by an administrator. Contact your admin or DPO for the retention policy.',
    retentionDays: 'Retention policy: documents older than {{days}} days may be removed.',
    retentionNotConfigured: 'Retention policy: not configured.',
    retentionRun: 'Run retention now',
    retentionRunSuccess: 'Retention run completed. {{count}} document(s) removed.',
    statsTitle: 'Usage Statistics',
    statsNote: 'Your usage summary from recent audit records (your activity only).',
    statsNoteAdmin: 'Organization-wide usage summary from recent audit records (all users).',
    documentsAnalyzed: 'Analyzed',
    diffsRun: 'Diffs',
    searchesRun: 'Searches',
  },
  admin: {
    publish: 'Publish for all users',
    publishing: 'Publishing…',
    published: 'Published — every user will see this.',
    publishHint: 'Edits above affect only this browser. Publishing saves the brand for everyone.',
    title: 'Admin Panel',
    desc: 'Customize branding, colors, gradients, and logos for both light and dark themes.',
    branding: 'Branding',
    darkTheme: 'Dark Theme',
    lightTheme: 'Light Theme',
    colors: 'Colors',
    accentColor: 'Accent / Primary Color',
    secondaryBtnColor: 'Secondary Button Color',
    headerBg: 'Header Background',
    backgroundColor: 'Page Background',
    surfaceColor: 'Card / Surface Color',
    titleColor: 'Text Color (Titles)',
    bodyColor: 'Text Color (Body)',
    textColor: 'Text Color (General)',
    lineColor: 'Line / Border Color',
    highlightColor: 'Highlight Color',
    navLinkColor: 'Header Link Color',
    navLinkActive: 'Header Link Active / Hover',
    sidebarAccent: 'Sidebar Accent Color',
    gradients: 'Gradients',
    headerGradient: 'Header Gradient',
    bgGradient: 'Background Gradient',
    logo: 'Company Logo',
    logoForTheme: 'Logo for {theme}',
    uploadLogo: 'Upload',
    changeLogo: 'Change',
    resetDefault: 'Reset to default',
    resetAll: 'Reset all to defaults',
  },
  usage: {
    title: 'Usage Reports',
    from: 'From',
    to: 'To',
    userId: 'User',
    allUsers: 'All users',
    loading: 'Loading…',
    refresh: 'Refresh',
    totalEvents: 'Total Events',
    servicesUsed: 'Services Used',
    activeUsers: 'Active Users',
    serviceUsage: 'Service Usage',
    topKeywords: 'Top Keywords',
    perUser: 'Per-User Breakdown',
    dailyActivity: 'Daily Activity',
    breakdown: 'Breakdown',
    noData: 'No data available.',
    coverageNote: 'Breakdown is based on the most recent {covered} of {total} total events.',
    svc_chat: 'Chat',
    svc_case_law_search: 'Case Law Search',
    svc_case_law_summarize: 'Case Law Summary',
    svc_case_law_compare: 'Case Law Compare',
    svc_stt: 'Speech-to-Text',
    svc_tts: 'Text-to-Speech',
    svc_chat_export: 'Chat Export',
    svc_contract_analysis: 'Document Analysis',
    svc_legislation_diff: 'Legislation Diff',
    svc_legislation_live_diff: 'Live Legislation Diff',
    svc_legislation_mixed_diff: 'Mixed Legislation Diff',
    svc_custom_document_diff: 'Custom Document Diff',
    svc_document_generation: 'Document Generation',
    svc_mevzuat_search: 'Mevzuat Search',
    svc_mevzuat_articles: 'Mevzuat Articles',
    svc_mevzuat_article_search: 'Mevzuat Article Search',
    svc_upload: 'Document Upload',
    svc_export: 'Export',
    svc_unknown: 'Other',
  },
  common: {
    retry: 'Try again',
    error: 'Error',
    close: 'Close',
    delete: 'Delete',
    selectFile: 'Select a file',
    uploadFailed: 'Upload failed',
    analysisFailed: 'Analysis failed',
    exportFailed: 'Export failed',
    loadFailed: 'Failed to load',
    selectTwoVersions: 'Select a law and both versions',
    selectTwoDifferent: 'Select two different versions',
  },
};

export default en;
